import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import { Flex } from '../grid';
import { P } from '../typography';

const RemoveButton = ({ onConfirm }) => {
  const [isOnRemoveCardConfirmation, setIsOnRemoveCardConfirmation] = useState(false);

  if (isOnRemoveCardConfirmation) {
    return (
      <Flex>
        <P variant={2} pr="0.5rem">
          Are you sure?
        </P>

        <ConfirmButton
          variant={2}
          pr="0.5rem"
          color="errorPrimary"
          title="Confirm Remove"
          data-testid="confirmRemove"
          onClick={event => {
            event.stopPropagation();
            onConfirm();
          }}
        >
          Remove
        </ConfirmButton>

        <Button
          variant={2}
          color="grey300"
          title="Cancel Remove"
          onClick={event => {
            event.stopPropagation();
            setIsOnRemoveCardConfirmation(false);
          }}
        >
          Cancel
        </Button>
      </Flex>
    );
  }

  return (
    <Button
      variant={2}
      color="grey300"
      title="Remove"
      data-testid="initialRemove"
      onClick={event => {
        event.stopPropagation();
        setIsOnRemoveCardConfirmation(true);
      }}
    >
      Remove
    </Button>
  );
};

const Button = styled(P).attrs(() => ({ as: 'button' }))`
  :hover {
    color: ${({ theme }) => theme.colors.bluePrimary};
    transition: color 0.2s ease-in;
  }
`;

const ConfirmButton = styled(P).attrs(() => ({ as: 'button' }))`
  :hover {
    color: ${({ theme }) => theme.colors.error400};
    transition: color 0.2s ease-in;
  }
`;

RemoveButton.propTypes = {
  onConfirm: PropTypes.func.isRequired,
};

export { RemoveButton };
